<template>
    <div>
        <div class="d-flex flex-lg-row flex-column w-100">
            <div v-show="show_sidebar" class="mb-3 mr-lg-3 standards-column col-lg-6 p-0">
                <div class="sticky" v-sticky="{zIndex: 10, stickyTop: 144}">
                    <div> <!-- vue sticky wrapper important -->
                        <b-card
                            no-body
                            header-bg-variant="light"
                            header-class="m-0 p-2"
                            v-for="(pub, pub_index) in unit_groups"
                            v-if="pub.id == publication.id"
                            :key="pub.id"
                        >
                            <template #header>
                                <div class="d-flex align-items-center">
                                    <b-form-select v-if="pub.id == publication.id" size="lg" v-model="workflow" class="border-0 bg-transparent">
                                        <b-form-select-option value="overview">
                                            <template v-if="pub.id == publication.id && unit_groups.length > 1">
                                                {{pub.sku}} - Overview
                                            </template>
                                            <template v-if="unit_groups.length == 1">
                                                Overview
                                            </template>
                                        </b-form-select-option>
                                        <b-form-select-option value="standards">
                                            Standards
                                        </b-form-select-option>
                                    </b-form-select>
                                </div>
                            </template>

                            <b-card-body class="p-0">
                                <div class="p-2 border-bottom">
                                    <b-form-input type="search" v-model="standards_search" placeholder="Search" class="mb-2"/>
                                    <div v-if="state_grade" class="d-flex justify-content-end m-2">
                                        <b-btn variant="danger" @click="clearStandardsByState(state_grade, publication)">Clear {{ state_grade.id }} Standards From Publication</b-btn>
                                    </div>
                                </div>

                                <div class="p-3 standard_scroll">
                                    <div v-if="filtered_standards.length">
                                        <div v-for="standard in filtered_standards" :key="standard.code" class="standard">
                                            <Standard :standard="standard" />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <b-alert variant="danger" :show="standards_search == '' && !filtered_standards.length" class="mb-0">
                                            0 Standards
                                        </b-alert>
                                        <b-alert variant="danger" :show="standards_search != '' && !filtered_standards.length" class="mb-0">
                                            0 results
                                        </b-alert>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-card>
                    </div>
                </div>
            </div>
            <div
                class="flex-grow-1 pl-0 pr-0"
                :class="show_sidebar ? 'col-lg-6 pr-lg-3' : 'col-12'"
            >
                <template v-for="pub in unit_groups">
                    <div v-for="unit_group in pub.unit_groups" :key="unit_group.id">
                        <unit-group
                            v-if="showUnitGroupComponent"
                            :ref="'unit-group' + unit_group.id"
                            :publication_id="publication.id"
                            :publication="pub"
                            :unit_group="unit_group"
                            :unit_groups="pub.unit_groups"
                            workflow="standards"
                            :dark="pub.id == publication.id ? true : false"
                            :state_grade="state_grade"
                            :selected_standard_year="selected_standard_year"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.standard_scroll{
    overflow-y: scroll;
    height:550px;
}

.sticky {
    .overview-group-list,
    .standards {
        max-height: calc(100vh - 296px);
        overflow: scroll;
        border-bottom-left-radius: .25rem;
        border-bottom-right-radius: .25rem;
    }

    .form-control {
        &:focus {
            outline: 0;
            box-shadow: none;
        }
    }
}
</style>

<script>

import { mapState } from 'vuex'
import VueSticky from 'vue-sticky'
import UnitGroup from '@/components/unit_group/Index'
import Standard from '@/components/standards/Standard'

export default {
    data: () => ({
        standards_search: '',
        showUnitGroupComponent: true
    }),
    props: [
        'publication',
        'state_grade',
        'selected_standard_year',
        'show_sidebar'
    ],
    components: {
        Standard,
        UnitGroup
    },
    directives: {
        'sticky': VueSticky,
    },
    computed: {
        ...mapState({
            unit_groups: state => state.unit_groups.unit_groups,
            standards: state => state.standards.standards,
        }),
        workflow: {
            get () {
                return this.$store.state.utilities.workflow
            },
            set (value) {
                this.$store.commit('setWorkflow', value)
            }
        },
        stateGrades() {
            let state_grades = []
            _.each(this.publication.state_grades, sg => {
                sg.id = sg.state + sg.grade
                state_grades.push(sg)
            })
            if(this.publication.linked_publication && this.publication.linked_publication.id) {
                state_grades.push({'state': 'NA', 'grade': this.publication.state_grades[0].grade})
            }
            return state_grades
        },
        filtered_standards () {
            if(!this.state_grade) return false;

            return this.standards.filter(standard => {

                if(
                    this.state_grade.standards_source == 'none'
                    ||
                    (this.state_grade.standards_source == 'national' && standard.state != 'NA')
                    ||
                    (this.state_grade.standards_source == 'state' && this.state_grade.state != standard.state)
                    ||
                    this.state_grade.grade > standard.high_grade 
                    || 
                    this.state_grade.grade < standard.low_grade
                    ||
                    (this.selected_standard_year != 'None' && this.selected_standard_year != standard.year) 
                ){
                    return false;
                }
                
                let search = null

                if (this.standards_search) {
                    search = this.standards_search.toLowerCase()
                }

                let searchMatch = false

                if(this.standards_search == '' || (standard.number && standard.number.toLowerCase().indexOf(search) > -1)) {
                    searchMatch = true
                }

                return searchMatch
            })
        }
    },
    watch: {
        'unit_groups' : {   
            handler(value) {
                // remount the unit_group component when the standard changes
                this.showUnitGroupComponent = false;
                this.$nextTick(() => {
                    this.showUnitGroupComponent = true;
                });
            }
        }
    },
    methods: {
        clearStandardsByState(state_grade, publication) {
            this.$swal({
                html: `This action will clear all <strong>${state_grade.id}</strong> standards from the current publication: <br /> <br /> <strong>${publication.sku} - ${publication.title}</strong><br /><br /> Are you sure you want to continue?`,
                showCancelButton: true,
                confirmButtonText: 'Clear Standards',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#E74C3C',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.unit_groups[0].unit_groups.forEach(unit_group => {
                        unit_group.units.forEach(unit => {
                            unit.standards
                                .filter(standard => standard.state === this.state_grade.state && standard.high_grade == this.state_grade.grade)
                                .forEach(standard => this.removeUnitStandards(unit.id, standard.guid));
                        });

                        unit_group.standards
                            .filter(standard => standard.state === this.state_grade.state && standard.high_grade == this.state_grade.grade)
                            .forEach(standard => this.removeUnitGroupStandards(unit_group.id, standard.guid));
                    });
                    this.$store.dispatch('getUnitGroups', this.publication.id)
                    
                }
            })
        },
        removeUnitGroupStandards(unit_group_id, standard_id) {
            this.axios.post('/api/unit_groups/remove_standard/' + unit_group_id, {
                standard_id: standard_id
            })
            .then((response) => {
                
            })
        },
        removeUnitStandards(unit_id, standard_id) {
            this.axios.post('/api/units/remove_standard/' + unit_id, {
                standard_id: standard_id
            })
            .then((response) => {
            
            })
        },
        assignSelectedState(){
            //prevent the default state from being DV when more than one state is assigned to the publication
            let state_grades = this.publication.state_grades;
            if(state_grades.length > 1){
                this.state_grade = state_grades[0].state == 'DV' ? state_grades[1] : state_grades[0]; 
            }
            else{
                this.state_grade = state_grades[0]
            }
        },
    },
}
</script>
